import React, { Component, useState } from 'react';
import { Card, CardBody, Row, Col, CardHeader, Button, Form, FormFeedback, FormGroup, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Link, Redirect } from 'react-router-dom'
import Postman from '../../utils/service'
import { Helmet } from 'react-helmet'
import './index.css'
import MailchimpModal from '../../components/mailchimpModal'
import AppContext from '../../AppContext'
import { _location } from '../../common/const'
import { decodeforspace, encodeforspace, encodeIndustryName, amountFormatter, showEzoicAds } from '../../utils/helper'
import { isEmpty } from '../../common/utils'

import { withRouter } from 'react-router-dom'
import Img from 'react-image'
import * as Yup from 'yup'
import Modal from 'react-modal'
import { Formik } from 'formik';
import ClipLoader from 'react-spinners/ClipLoader'
import { connect } from 'react-redux'
import { getCompanybyName } from '../../actions/CompanyAction'
import { Competitors } from './Competitors';
import { CompanyPeople } from './CompanyPeople';
import { OtherCompanies } from './OtherCompanies';
import LazyLoad from 'react-lazyload';
import ReactHtmlParser from 'react-html-parser';
import iconOne from '../../assets/img/company/icon-1.png';
import iconSec from '../../assets/img/company/icon-2.png';
import iconThrd from '../../assets/img/company/icon-3.png';
import iconOneDes from '../../assets/img/company/icondis-1.png';
import iconSecDes from '../../assets/img/company/icondis-2.png';
import iconThrdDes from '../../assets/img/company/icondis-3.png';
import iconFrthDes from '../../assets/img/company/icondis-4.png';
import iconFifthDes from '../../assets/img/company/icondis-5.png';
import iconSixDes from '../../assets/img/company/icondis-6.png';
import growjoRankIcon from '../../assets/img/logo-icon.png';
import adImg from '../../assets/img/adblockimg.jpg';
import AdSense from 'react-adsense';
import Cookies from 'js-cookie';

var dateFormat = require('dateformat')
const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];
const main_server = config.main_server
Modal.setAppElement('#root')
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '450px',
    border: 0,
    padding: 33,
    paddingTop: 20,
    paddingBottom: 20,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};
const FundingTable = ({ data, companyName }) => {
  if (isEmpty(data)) return null;
  return (
    <React.Fragment>
      <h2 id='funding-rounds' >{companyName} Funding</h2>
      <table className="table table-bordered cstm-table">
        <thead>
          <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
            <th scope="col">Date</th>
            <th scope="col">Amount</th>
            <th scope="col">Round</th>
            <th scope="col">Lead Investors</th>
            <th scope="col">Reference</th>
          </tr>
        </thead>
        <tbody>
          {
            data.map((item, index) => (
              <tr key={index + 'funding'}>
                <td>{item.date_created}</td>
                <td>${item.Amount}</td>
                <td>{item.Round}</td>
                <td>{item.LeadInvestors}</td>
                <td><a href={item.news_url} target="_blank">Article</a></td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </React.Fragment>
  )
}

const MATable = ({ data, companyName }) => {
  if (isEmpty(data)) return null;
  return (
    <React.Fragment>
      <h2 id='acquisitions'>{companyName} Acquisitions</h2>
      <table className="table table-bordered">
        <thead>
          <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
            <th scope="col">Date</th>
            <th scope="col">Company Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Notes</th>
            <th scope="col">Reference</th>
          </tr>
        </thead>
        <tbody>
          {
            data.map((item, index) => (
              <tr key={index + 'funding'}>
                <td>{item.date_created}</td>
                <td>{item.acquired_company_name}</td>
                <td>{item.Amount}</td>
                <td>{item.notes}</td>
                <td><a href={item.URL} target="_blank">Article</a></td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </React.Fragment>
  )
}


const CompanyContactsTable = ({ data, companyName }) => {
  if (isEmpty(data)) return null;
  return (
    <React.Fragment>
      <div className="col-md-6 p-0">
        <h2 id='companyContactsTable'>{companyName} Executives</h2><br />
        <table className="table table-bordered cstm-table">
          <thead>
            <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
              <th scope="col">Name</th>
              <th scope="col">Title</th>
            </tr>
          </thead>
          <tbody>
            {
              data.map((item, index) => (
                <tr key={index + 'companyContacts'}>
                  <td>{item.first_name + " " + item.last_name}</td>
                  <td>{item.title}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </React.Fragment>
  )
}


const NewsTable = ({ data, companyName }) => {
  if (isEmpty(data)) return null
  return (
    <React.Fragment>
      <h2 id='company-news'>{companyName} News</h2>
      {
        data.map((item, index) => {
          return (
            <div key={item.Date + index}>
              <span style={{ display: "block" }}><span>{item.Date}</span> - <a style={{ fontSize: 16 }} href={`${item.Link}`} target="_blank">{item.Title}</a></span>
              <p>{item.Description}</p>
            </div>
          )
        })
      }
    </React.Fragment>
  )
}

const convertDateFormat = time => dateFormat(time, "mmmm yyyy")
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
class CompanyDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data,
      subscribe: false,
      industryImg: true,
      stateImg: true,
      cityImg: true,
      modalIsOpen: false,
      missingCompany: '',
      showAd: false,
      redirectUrl: '',
      hasAdCompetitor: false,
      searchedQueryString: '',
      name: '',
      callingApi: false,
      embedModalIsOpen: false,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,

    }
  }
  editcompany = () => {
    this.setState({ modalIsOpen: true })
  }
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  closeEmbedModal = () => {
    this.setState({ embedModalIsOpen: false });
  }
  getQueryStrings(location) {

    var assoc = {};
    var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
    var queryString = location.search.substring(1);
    var keyValues = queryString.split('&');

    for (var i in keyValues) {
      var key = keyValues[i].split('=');
      if (key.length > 1) {
        assoc[decode(key[0])] = decode(key[1]);
      }
    }

    return assoc;
  }

  componentDidUpdate() {

    const name = decodeforspace(this.props.match.params.name)
    const searchedQueryString = this.getQueryStrings(this.props.location)
    if (name == this.state.companyName && searchedQueryString == this.state.searchedQueryString) {
      return false
    }
    const showScriptFor = ['ZoomInfo', 'SalesIntel.io', 'LeadIQ', 'UpLead', 'Cognism', 'Rocketreach', 'Lusha', 'InsideView', 'DiscoverOrg', 'SalesLoft', 'Outreach', 'Highspot', 'Apollo'];

    if (document.getElementById("customJs") && !document.querySelector("#customJs script")) {
      if (showScriptFor.includes(this.state.data.company_name) && document.getElementById("customJs").innerHTML == '') {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.innerHTML = "(function(){console.log('Adding Custom script'); window.ldfdr = window.ldfdr || {}; (function(d, s, ss, fs){ fs = d.getElementsByTagName(s)[0]; function ce(src){ var cs = d.createElement(s); cs.src = src; setTimeout(function(){fs.parentNode.insertBefore(cs,fs)}, 1); } ce(ss); })(document, 'script', 'https://sc.lfeeder.com/lftracker_v1_YEgkB8lvjqv4ep3Z.js'); })();";
        document.getElementById("customJs").innerHTML = "";
        document.getElementById("customJs").appendChild(s)
      } else {
        document.getElementById("customJs").innerHTML = "";
      }

    }


  }


  componentDidMount() {
    const name = decodeforspace(this.props.match.params.name)
    const searchedQueryString = this.getQueryStrings(this.props.location)
    if (name == this.state.companyName && searchedQueryString == this.state.searchedQueryString) {
      return false
    }
    if (this.state.callingApi) {
      return false
    }
    this.setState({ callingApi: true })
    Postman.getCompanyByName(name, searchedQueryString)
      .then(res => {
        this.setState({ callingApi: false })

        if (res.data.success === false) {
          if (res.data.errorCode == 302) {
            this.setState({ redirectUrl: res.data.newUrl })
          } else if (res.data.errorCode == 404) {
            this.setState({ redirectUrl: '/' })
          }
        } else {
          this.setState({ data: res.data, searchedQueryString, companyName: name })
          showEzoicAds([102, 121, 128]);
        }

        this.setState({ showAd: false })

        setTimeout(() => {
          this.setState({ showAd: true })
        }, 1000)


      }).catch(err => {
        this.setState({ callingApi: false })
      })


  }
  componentWillReceiveProps(nextprops, nextstate) {
    const name = decodeforspace(nextprops.match.params.name)
    const searchedQueryString = this.getQueryStrings(this.props.location)

    if (name == this.state.companyName && searchedQueryString == this.state.searchedQueryString) {
      return false
    }
    if (this.state.callingApi) {
      return false
    }
    this.setState({ callingApi: true })
    this.setState({ showAd: true, redirectUrl: '' })




    Postman.getCompanyByName(name, searchedQueryString)
      .then(res => {
        this.setState({ callingApi: false })
        this.setState({ data: res.data, searchedQueryString, companyName: name }, () => this.forceUpdate())
        showEzoicAds([102, 121, 128]);
        console.log('hiding')
        this.setState({ showAd: false })

        setTimeout(() => {
          console.log('showing')
          this.setState({ showAd: true })
        }, 1000)


      }).catch(err => {
        this.setState({ callingApi: false })
      })

  }
  press = (company, ranking) => {
    this.props.history.push({
      pathname: `/press/${encodeforspace(company)}`,
      state: { company, ranking }
    })
  }
  editcompany = company_name => {
    this.props.getCompanybyName(company_name)
    this.props.history.push('/edit_company/' + encodeforspace(company_name))
  }

  onClaimYourProfileClick = () => {
    if (this.props.user.email) {
      this.props.history.push('/register-company')
    } else {
      this.props.history.push('/join')
    }
  }

  render() {

    if (this.state.redirectUrl != '') {
      return <Redirect
        to={{ pathname: this.state.redirectUrl, state: { status: 302 } }}
      />;
    }

    if (isEmpty(this.state.data)) return null;
    const { Accelerator, btype, valuation, total_funding_float, pricing, company_name, city, current_employees, industryRanking, stateRanking,
      LeadInvestors, keywords, last_employees, estimated_revenues, job_openings, ranking, bio, state, country, url, Industry, founded, top3news, competitors,
      twitter_username, MACompanyPresses, FundingCompanyPresses, HiringPlansCompanyPresses, NewHireCompanyPresses, NewLocationCompanyPresses, StaffCutsCompanyPresses,
      cityRanking, metro_city, executive_contacts, citypage, valuation_as_of, companyContacts, companyPeople
      , other_companies
    } = this.state.data

    const company_id = this.state.data.id

    if (company_name == undefined) return null
    var userEmail, isEditableCompany;
    if (this.props.user.email) {
      userEmail = this.props.user.email;
      isEditableCompany = (userEmail.indexOf('@' + url) > 0) ? true : false
    }

    const total_pricing = pricing ? pricing : null
    const total_funding = !total_funding_float ? null :
      total_funding_float >= 1000 ? `$${Math.round(total_funding_float / 100) / 10}B` :
        `$${total_funding_float}M`
    const _ranking = (ranking <= 10000) && (ranking) ? `#${ranking}` : '';
    const _country = !country ? '' :
      country == 'United States' ? 'USA' : country;
    const _estimated_revenues = estimated_revenues ? '$' + amountFormatter(estimated_revenues, 1) : 'N/A'
    const _job_openings = job_openings ? job_openings : 'N/A'
    const stateLink = state ? <Link to={`/state/${state}`}>{state}</Link> : ''
    const cityLink = metro_city ? <Link to={`/city/${encodeforspace(metro_city)}`}>{metro_city}</Link> : city
    const location = (
      <div>
        {(city || metro_city) ? <React.Fragment>{cityLink}, {stateLink} {_country}</React.Fragment> : <React.Fragment>{stateLink} {_country}</React.Fragment>}
      </div>
    )

    const _industry = Industry ? Industry : 'N/A'

    var industry_brand = Industry;
    if (Industry == 'Hospital/Healthcare') industry_brand = 'HospitalHealthcare'
    if (Industry == 'PR/Comm') industry_brand = 'PRComm'
    if (Industry == 'VC/PE') industry_brand = 'VC PE'
    if (Industry == 'Energy/Oil') industry_brand = 'EnergyOil'

    var industry_link = encodeIndustryName(Industry);

    const _keywords = keywords ? keywords : 'N/A'
    const _Accelerator = Accelerator ? Accelerator : 'N/A'
    const _valuation = valuation ? '$' + amountFormatter(valuation, 1) : 'N/A'
    const _total_funding = total_funding ? total_funding : 'N/A'
    const company_url = (url == 'mavrck.co') ? `https://www.${url}` : `//${url}`
    const employee_growth = current_employees && last_employees ? Math.round((current_employees - last_employees) / last_employees * 100) + '%' : 'N/A'
    let googleNews = []

    top3news.map((item) => {
      googleNews.push({ Date: item.day_only/*d.toLocaleDateString("en-GB", options)*/, Link: item.source, Title: item.title, Description: item.description })
    });

    // if (growjo_news !== null) {
    //   if (Date1 && !googleNews.find(o => o.Link == Link1)) {
    //     googleNews.push({ Date: Date1, Link: Link1, Title: Title1, Description: Description1 })
    //   }
    //   if (Date2 && !googleNews.find(o => o.Link == Link2)) {
    //     googleNews.push({ Date: Date2, Link: Link2, Title: Title2, Description: Description2 })
    //   }
    //   if (Date3 && !googleNews.find(o => o.Link == Link3)) {
    //     googleNews.push({ Date: Date3, Link: Link3, Title: Title3, Description: Description3 })
    //   }
    // }

    const isRevenues = estimated_revenues || (fundingAmount && fundingDate) || (estimated_revenues && current_employees) || total_funding
    const fundingDate = isEmpty(FundingCompanyPresses) ? null : FundingCompanyPresses[FundingCompanyPresses.length - 1].date_created
    const fundingAmount = isEmpty(FundingCompanyPresses) ? null : FundingCompanyPresses[FundingCompanyPresses.length - 1].Amount

    let metaCompetitors = competitors.slice(0, 3);
    const hasAdCompetitor = competitors.find(o => o.sort < '100')

    metaCompetitors = metaCompetitors.map(x => x.company_name)
    metaCompetitors = [
      metaCompetitors.slice(0, -1).join(', '),
      metaCompetitors.slice(-1)[0]
    ].join(metaCompetitors.length < 2 ? '' : ' and ')
    /* ad block for Ad */
    function AdBlock() {
      return (
        <div className='w-100'>
          <img style={{ maxHeight: '500px', width: '100%' }} src={adImg} />
        </div>
      )
    }
    let springBadgeImgName = false;
    let showAdd = false;
    let showAd1 = true;
    let showAd2 = false;
    let showAd3 = true;
    if (ranking) {
      if (ranking <= 1000) {
        springBadgeImgName = 'growjo-leader-spring25.png';
      } else if (ranking > 1000 && ranking <= 9000) {
        springBadgeImgName = 'growjo-spring25.png';
      }
    }

    return (
      <div className="animated fadeIn mainView" style={{ height: '100%' }} data-bs-spy="scroll" data-bs-target=".navbar" data-bs-offset="50">
        <Helmet>

          <title>{company_name}: Revenue, Competitors, Alternatives</title>
          <meta name="description" content={`${company_name} top competitors are ${metaCompetitors} and they have annual revenue of ${_estimated_revenues}  and ${current_employees}  employees.`} />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card className='modifyCard' style={{ height: '100%' }}>
          <CardHeader style={{ backgroundColor: 'white', paddingTop: '0px', marginTop: '-10px', paddingBottom: '0px' }}>

            <div className='companyNav'>
              <ul className='navigation' >
                <li><a href="#company-overview" style={{ margin: 0 }}>Overview</a></li>
                {isRevenues && <li><a href="#revenue-financials">Revenue & Valuation</a></li>}
                {!isEmpty(competitors) && <li><a href="#competitors">Competitors</a></li>}
                <li><a href="#what-is">What Is {company_name}?</a></li>
                <li><a href="#employee-data">Employee Data</a></li>
                {!isEmpty(googleNews) && <li><a href="#company-news">News</a></li>}
                {/* {!isEmpty(companyContacts) && <li><a href="#companyContactsTable">Executives</a></li>} */}
                {!isEmpty(FundingCompanyPresses) && <li><a href="#funding-rounds">Funding/Rounds</a></li>}
                {!isEmpty(NewHireCompanyPresses) && <li><a href="#new-executives">New Executives</a></li>}
                {!isEmpty(NewLocationCompanyPresses) && <li><a href="#new-location">New Offices</a></li>}
                {!isEmpty(MACompanyPresses) && <li><a href="#acquisitions">Acquisitions</a></li>}
                {!isEmpty(HiringPlansCompanyPresses) && <li><a href="#hiring-plans">Hiring Plans</a></li>}
                {!isEmpty(StaffCutsCompanyPresses) && <li><a href="#staff-cuts">Staff Cuts</a></li>}

                <li><Dropdown direction="down" isOpen={this.state.btnDropright} toggle={() => { this.setState({ btnDropright: !this.state.btnDropright }); }}>
                  <DropdownToggle className='rounded-circle' caret>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem className='navigation-first'> {isRevenues && <a href="#revenue-financials">Revenue & Valuation</a>}</DropdownItem>
                    <DropdownItem className='navigation-sec'>{!isEmpty(competitors) && <a href="#competitors">Competitors</a>}</DropdownItem>
                    <DropdownItem className='navigation-thrd'><a href="#what-is">What Is {company_name}?</a></DropdownItem>
                    <DropdownItem><a href="#employee-data">Employee Data</a></DropdownItem>
                    <DropdownItem>{!isEmpty(googleNews) && <a href="#company-news">News</a>}</DropdownItem>
                    <DropdownItem>{!isEmpty(FundingCompanyPresses) && <a href="#funding-rounds">Funding/Rounds</a>}</DropdownItem>
                  </DropdownMenu>
                </Dropdown></li>
              </ul>
            </div>
          </CardHeader>
          <CardBody className='tempCompany' style={{ height: '100%' }}>
            <div className='row'>
              <div className='col-12 col-sm-8 '>
                <div className='row py-3'>
                  <div className='col '>
                    <h1 className='' style={{ color: '#000', fontSize: 24, marginBottom: 0, fontWeight: 800 }}>
                      {company_name} Revenue and Competitors
                    </h1>
                  </div>
                  <div className='col-3'>
                    {!(this.props.user.email && this.props.user.company && this.props.user.company.company_name) &&
                      // <div className='headerBtn' onClick={this.onClaimYourProfileClick}>
                      //   <span>Claim your profile</span>
                      // </div>

                      <Link to={`/company_data_api`}>License our Company Data API</Link>
                    }
                    {isEditableCompany &&
                      <div className='editBtn' onClick={() => this.editcompany(company_name)}>
                        <span>Edit</span>
                      </div>
                    }
                  </div>
                </div>
                <div className='row m-0'>
                  <div className='company-badge-new col-12'>

                    <Row className='m-0'>
                      <Col className=' d-flex p-0' xs={12}>

                        <div className='custm-grid  p-2 w-100 custm-grid' id='revenue-financials'>
                          <div className='col'>

                            <a href={company_url} target="_blank" style={{ textDecoration: 'none' }}><Img style={{ maxHeight: '60px' }} src={[`//logo.clearbit.com/${url}?size=100`, '/static/img/company_default.png']} /></a>

                          </div>

                          <div className='col' style={{ display: 'flex' }}>
                            <div className='icon col-4 p-0 d-flex justify-content-center align-items-center m-auto'>
                              <img className='no-flex-basis' src={iconOne} />
                            </div>
                            <div className='cmpny-data col p-0 d-flex justify-content-start align-items-start flex-column pl-2'>
                              <h4 style={{ fontSize: 14, color: '#000' }}>{location}</h4>
                              <small style={{ fontSize: 12, color: '#8083A3' }}>Location</small>
                            </div>
                          </div>



                          {ranking && ranking <= 10000 && <div className='col' style={{ display: 'flex' }}>
                            <div className='icon col-4 p-0 d-flex justify-content-center align-items-center m-auto'>
                              <img className='no-flex-basis' src={growjoRankIcon} />
                            </div>
                            <div className='cmpny-data col p-0 d-flex justify-content-start align-items-start flex-column pl-2'>
                              <h4 style={{ fontSize: 14, color: '#000' }}>#{ranking}</h4>
                              <h4 style={{ fontSize: 12, color: '#8083A3' }}>Growjo Ranking</h4>
                            </div>
                          </div>}


                          {(!ranking || ranking > 10000) && _total_funding && <div className='col' style={{ display: 'flex' }}>
                            <div className='icon col-4 m-auto d-flex justify-content-center align-items-center'>
                              <img src={iconSec} />
                            </div>
                            <div className='cmpny-data col d-flex justify-content-start align-items-start flex-column pl-2'>
                              <h4 style={{ fontSize: 14, color: '#000' }}>{_total_funding}</h4>
                              <small style={{ fontSize: 12, color: '#8083A3' }}>Total Funding</small>
                            </div>
                          </div>}
                          <div className='col' style={{ display: 'flex' }}>
                            <div className='icon col-4 m-auto d-flex justify-content-center align-items-center'>
                              <img src={iconThrd} />
                            </div>
                            <div className='cmpny-data col d-flex justify-content-start align-items-start flex-column pl-2'>
                              <h4 style={{ fontSize: 14, color: '#000' }}>{Industry && <Link to={`/industry/${encodeURIComponent(industry_link)}`}>{_industry}</Link>}</h4>
                              <small style={{ fontSize: 12, color: '#8083A3' }}>Industry</small>
                            </div>
                          </div>
                        </div>
                      </Col>

                    </Row>
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-4 pt-2 px-0 badge-main'>
                <Col style={{ textAlign: 'center' }} className='d-flex flex-column badge-div' lg={7}>

                  {springBadgeImgName &&
                    <React.Fragment>
                      <img style={{ width: '150px', maxHeight: '150px' }} src={'/static/badges/' + springBadgeImgName} />
                      <a className='mt-2 btn text-primary' onClick={() => { this.setState({ embedModalIsOpen: true }) }} style={{ fontWeight: '800', textAlign: 'left', paddingLeft: '2.5rem' }}><i className="fa fa-code" aria-hidden="true"></i>Embed</a>
                      <Modal
                        isOpen={this.state.embedModalIsOpen}
                        onRequestClose={() => { this.setState({ embedModalIsOpen: false }) }}
                        contentLabel="Embed Badge"
                        shouldFocusAfterRender={true}
                        shouldCloseOnOverlayClick={true}
                        ariaHideApp={true}
                        style={{
                          overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                          },
                          content: {
                            position: 'absolute',
                            top: '200px',
                            left: '50%',
                            border: '1px solid #ccc',
                            background: '#fff',
                            overflow: 'auto',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '15px',
                            outline: 'none',
                            padding: '20px',
                            width: '600px',
                            maxHeight: '570px',
                            transform: 'translate(-50%,-100px)'
                          }
                        }}
                      >
                        <div className='col-12 d-flex justify-content-center align-items-center flex-column'>
                          <div className='col-12 d-flex justify-content-center align-items-center'>
                            <h3 style={{ color: '#000', fontSize: '18px', fontWeight: '800', textTransform: 'capitalize' }}>Select embed code</h3>
                            <a className='mt-2 btn close' onClick={() => { this.setState({ embedModalIsOpen: false }) }} style={{ fontWeight: '800', position: 'absolute', top: '-17px', right: '0', paddingLeft: '2.5rem' }}><i className="fa fa-close" aria-hidden="true"></i></a>
                          </div>

                          <div className='col-12 pt-3 d-flex justify-content-center align-self-end align-items-center flex-column'>
                            <img style={{ width: '150px', maxHeight: '150px' }} src={'/static/badges/' + springBadgeImgName} />



                            <TextAreaEmbed imgPath={springBadgeImgName} companyName={company_name} />
                          </div>
                        </div>
                      </Modal>
                    </React.Fragment>
                  }

                </Col>
                {showAd1 && <div className='col'>


                </div>
                }
              </div>
            </div>

            <div className="description-box py-3" >
              <Row style={{ marginBottom: 0 }}>
                <div class='col-md-5 ' >
                  {
                    isRevenues && <div>
                      <h2  >Estimated Revenue & Valuation</h2>
                      <ul style={{ marginBottom: 5 }}>
                        {estimated_revenues && <li>{company_name}'s estimated annual revenue is currently {_estimated_revenues} per year.
                          <span className="tooltip-icon">
                            <Link to={this.state.isLoggedIn ? `/aboutus` : '/join'}>(i)</Link>
                          </span>

                        </li>}
                        {fundingAmount && fundingDate && <li>{company_name} received ${fundingAmount} in venture funding in {convertDateFormat(fundingDate)}.</li>}
                        {estimated_revenues && current_employees && <li>{company_name}'s estimated revenue per employee is ${numberWithCommas(Math.round(estimated_revenues / current_employees))}</li>}
                        {total_funding && <li>{company_name}'s total funding is {total_funding}.</li>}
                        {total_pricing && <li>{company_name}'s pricing is {total_pricing} per year.</li>}
                        {valuation && <li>{company_name}'s  current valuation is {_valuation}. {valuation_as_of ? '(' + valuation_as_of + ')' : ''}</li>}
                      </ul>
                    </div>
                  }
                  {!hasAdCompetitor &&
                    <div>
                      <h2 id='employee-data' >Employee Data</h2>
                      <ul>
                        {current_employees && <li>{company_name} has {current_employees} Employees.
                          <span className="tooltip-icon">
                            <Link to={this.state.isLoggedIn ? `/aboutus` : '/join'}>(i)</Link>

                          </span>
                        </li>}
                        {current_employees && last_employees && <li>{company_name} grew their employee count by {employee_growth} last year.</li>}
                      </ul>
                    </div>
                  }
                </div>

                {hasAdCompetitor &&
                  <Col lg={5}>
                    <h2 id='employee-data' >Employee Data</h2>
                    <ul>
                      {current_employees && <li>{company_name} has {current_employees} Employees.
                        <span className="tooltip-icon">
                          <Link to={this.state.isLoggedIn ? `/aboutus` : '/join'}>(i)</Link>


                        </span>
                      </li>}
                      {current_employees && last_employees && <li>{company_name} grew their employee count by {employee_growth} last year.</li>}
                      <li>{company_name} currently has {_job_openings} job openings.</li>
                    </ul>
                  </Col>}




                {showAd1 && this.state.showAd && <div className='col-7' style={{ paddingTop: '25px', paddingRight: "50px" }}>
                  <AdSense.Google
                    client='ca-pub-1304487994033637'
                    slot='6575433867'
                    style={{ display: "block" }}
                    responsive='true'
                    format="auto"
                  />
                  {/* <div id="ezoic-pub-ad-placeholder-121"> </div> */}
                </div>}
                {companyPeople && <CompanyPeople data={companyPeople} companyName={company_name} company_id={company_id} />}

                {this.state.companyName == 'finder' &&
                  <div className='col-7' style={{ paddingTop: '25px', paddingRight: "50px" }}>
                    <h3>
                      Check out the <Link to="/aboutus">Growjo Company API</Link> which includes:
                    </h3>
                    <ul>
                      <li>Private Company Revenue Data</li>
                      <li>Employee Size and Growth</li>
                      <li>News events and more  <Link to="/aboutus">company data</Link> fields.</li>
                    </ul>
                  </div>
                }
              </Row>
              <div className='row'>
                <div className='col'>
                  <Competitors history={this.props.history} location={{ location: this.props.location }} data={competitors} industry={Industry} company={this.state.data} /></div>
                {showAd2 && this.state.showAd && <div className='col-12 col-sm-3'>
                  {/* <!-- Ezoic - sidebar_floating_1 - sidebar_floating_1 --> */}
                  <div>
                    {/* <div id="ezoic-pub-ad-placeholder-102"> </div> */}
                    <AdSense.Google
                      // key={'300x253-' + this.props.location.key}
                      // layoutKey={'google-ad2' + this.props.location.key}
                      client='ca-pub-1304487994033637'
                      slot='2282275062'
                      style={{ display: "block" }}
                      responsive='true'
                      format="auto"
                    />
                  </div>
                  <div>

                    <AdSense.Google
                      // key={'300x253-' + this.props.location.key}
                      // layoutKey={'google-ad2' + this.props.location.key}
                      client='ca-pub-1304487994033637'
                      slot='7175547086'
                      style={{ display: "block" }}
                      responsive='true'
                      format="auto"
                    />

                  </div>

                  {/* <!-- End Ezoic - sidebar_floating_1 - sidebar_floating_1 --> */}
                </div>}
              </div>
              <div>
                <div className="">
                  <h2 id='what-is' >What Is {company_name}?</h2>
                </div>
                <p>
                  {ReactHtmlParser(bio)}
                </p>
                <strong style={{ marginRight: 10 }}>keywords:</strong>{_keywords}<br />
              </div>
              <div className="col-md-12 text-center" >

                {/* {this.state.showAd &&
                 
                  <LazyLoad>
                   
                  </LazyLoad>
                } */}
              </div>
            </div>
            <div className="col-md-12">
              <div style={{ marginTop: 10, display: "flex", justifyContent: "space-around", flexWrap: "wrap" }}>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconOneDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{_total_funding}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Total Funding</p>
                </div>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconSecDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{current_employees ? current_employees : 'N/A'}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Number of Employees</p>
                </div>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconThrdDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{_estimated_revenues}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Revenue (est)</p>
                </div>


              </div>
              <div style={{ marginTop: 50, display: "flex", justifyContent: "space-around", flexWrap: "wrap", marginBottom: 25 }}>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconFrthDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{employee_growth}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Employee Growth %</p>
                </div>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconFifthDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{_valuation}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Valuation</p>
                </div>
                <div className='col d-flex justify-content-start align-items-baseline'>
                  <img src={iconSixDes}></img>
                  <p style={{ fontSize: 18, color: '#000', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>{_Accelerator}</p>
                  <p style={{ fontSize: 14, color: '#8083A3', fontWeight: 'normal' }}>Accelerator</p>
                </div>

              </div>
            </div>



            <NewsTable data={googleNews} companyName={company_name} />

            {/* <div className="col-md-12 text-center">
              {this.state.showAd &&
                <LazyLoad>

                </LazyLoad>
              }
            </div> */}
            <div class="row">
              {showAd2 && this.state.showAd && <div className='col-12 '>
                <AdSense.Google
                  client='ca-pub-1304487994033637'
                  slot='1108794195'
                  style={{ display: "block" }}
                  responsive='true'
                  format="auto"
                />
                {/* <div id="ezoic-pub-ad-placeholder-128"> </div> */}
              </div>}
            </div>

            <div className="row">
              <OtherCompanies location={{ location: this.props.location }} data={other_companies} city={city} company={this.state.data} />
            </div>
            <div className="row">
              <FundingTable data={FundingCompanyPresses} companyName={company_name} />
            </div>
            <LazyLoad className="row">
              <MATable data={MACompanyPresses} companyName={company_name} />
            </LazyLoad>

            {/* <div className="row">
              <CompanyContactsTable data={companyContacts} companyName={company_name} />
            </div> */}

            {isEditableCompany &&
              <MailchimpModal modalIsOpen={this.state.subscribe} closeModal={() => this.setState({ subscribe: false })} />
              &&
              <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Example Modal"
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                ariaHideApp={true}
              >
                <SubscribeForm company={company_name} />
              </Modal>
            }
          </CardBody>
        </Card>
        <span id="customJs"></span>
      </div >

    );
  }
}
class SubscribeForm extends Component {
  ValidationSchema = Yup.object().shape({
    Name: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    EMAIL: Yup.string()
      .email('Invalid email')
      .required('Required'),
  });
  constructor(props) {
    super(props)
    this.state = {
      subscribe: '',
      errorMsg: '',
      successMsg: '',
      errMsg: '',
      sendingEmail: false,
      startTyping: false
    }
  }
  onSubmit = (values, { resetForm }) => {
    this.setState({ sendingEmail: true, startTyping: false, errMsg: '', successMsg: '' })
    values.company = this.props.company
    resetForm()
    Postman.subscribeToEditCompany(values)
      .then(() => {
        this.setState({ successMsg: 'Please check email to edit this company.', sendingEmail: false })
      }
      )
      .catch(error => {
        this.setState({ errMsg: 'There is something wrong with your email! Can you try again, please?', sendingEmail: false })
      })
  }
  handleChange = () => {
    this.setState({ startTyping: true, errMsg: '', successMsg: '' })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ subscribe: nextProps.sendingState, errorMsg: nextProps.errorMsg })
  }
  render() {

    return (
      <div>
        <span style={{ fontSize: 20, width: 100 }}>To Edit this Company, you must work at this company. Please submit your email to verify.</span>
        <Formik
          initialValues={{
            EMAIL: '',
            Name: ''
          }}
          validationSchema={this.ValidationSchema}
          onSubmit={this.onSubmit}
          handleChange={this.handleChange}
        >
          {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
            <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ marginTop: 25 }}>
              <FormGroup>
                <InputGroup>
                  <Input type="name"
                    name="Name"
                    id="Name"
                    placeholder="Full Name"
                    valid={!errors.Name && values.Name != ''}
                    invalid={touched.Name && !!errors.Name}
                    autoFocus={false}
                    onChange={(e) => { handleChange(e); this.handleChange(); }}
                    required
                    value={values.Name} />
                  <div className="input-group-append">
                    <span className="input-group-text"><i className="fa fa-user"></i></span>
                  </div>
                  <FormFeedback>{errors.Name}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <Input type="email"
                    name="EMAIL"
                    id="EMAIL"
                    placeholder="Work Email"
                    valid={!errors.EMAIL && values.EMAIL != ''}
                    invalid={touched.EMAIL && !!errors.EMAIL}
                    autoFocus={false}
                    onChange={(e) => { handleChange(e); this.handleChange(); }}
                    required
                    value={values.EMAIL} />
                  <div className="input-group-append">
                    <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                  </div>
                  <FormFeedback>{errors.EMAIL}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <div style={{ textAlign: 'center' }}>
                <ClipLoader
                  sizeUnit={"px"}
                  size={30}
                  color={'grey'}
                  loading={this.state.sendingEmail}
                />
                {this.state.startTyping && <p style={{ color: 'red' }}>Must be a work domain.</p>}
                <p style={{ color: '#4dbd74' }}>{this.state.successMsg}</p>
                <p style={{ color: 'red' }}>{this.state.errMsg}</p>
              </div>
              <FormGroup style={{ marginLeft: 10 }}>
                <Button
                  type="submit" color="success" className="mr-1" style={{ float: "right" }}>Verify</Button>
              </FormGroup>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

class TextAreaEmbed extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      copySuccess: '',
      imgPath: props.imgPath,
      companyName: props.companyName
    }
  }

  componentWillReceiveProps(nextProps) {
    const imgPath = nextProps.imgPath;
    const companyName = nextProps.companyName;
    this.setState({ imgPath, companyName });
  }

  copyToClipboard = (e) => {
    this.textArea.select();
    document.execCommand('copy');

    e.target.focus();
    this.setState({ copySuccess: 'Copied!' });
  };

  render() {
    return (
      <div className="col d-flex flex-column pt-2">

        {

          document.queryCommandSupported('copy') &&
          <div className='d-flex justify-content-center align-items-center text-center order-2 pt-2'>
            <button className='btn btn-primary mt-2 ' onClick={this.copyToClipboard}><i class="fa fa-copy"></i> Copy Embed</button>
            <span className='ml-4 text-success'>{this.state.copySuccess}</span>
          </div>
        }
        <form>
          <textarea className='customTextArea'
            style={{ width: '100%', resize: 'none', background: '#fff', borderRadius: '10px', boxShadow: '0 1px 2px rgba(0,0,0,0.12)inset', color: '#5555', borderColor: 'none', height: '80px' }}
            ref={(textarea) => this.textArea = textarea}
            value={`<a  href="https://growjo.com/company/${encodeforspace(this.state.companyName)}"><img style="width: 125px;" src="https://growjo.com/static/badges/${this.state.imgPath}" /></a>`}
            readOnly />
        </form>
      </div>
    );
  }

}


//CompanyDetail.contextType = AppContext;
const mapStateToProps = state => ({
  user: state.auth.user,
})
const WithRouterCompanyDetail = withRouter(connect(mapStateToProps, { getCompanybyName })(CompanyDetail))
class CompanyDetailWrapper extends React.Component {
  render() {
    return (
      <WithRouterCompanyDetail data={this.context || []} {...this.props} />
    )
  }
}
CompanyDetailWrapper.contextType = AppContext;
export default CompanyDetailWrapper;



// WEBPACK FOOTER //
// ./client/src/views/CompanyDetail/index.js